export async function getErrorMessage(res: Response): Promise<string | null> {
  try {
    const data = await res.json() as { error?: { message?: string }; message?: string };
    return data.error?.message || data.message || null;
  } catch { // eslint-disable-line no-restricted-syntax -- non-JSON response body fallback
    return null;
  }
}
